import type { ReactNode } from "react";

import { Tooltip } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { useDemoModeDisabled } from "app/pages/sales-intelligence/hooks/demo-mode/useDemoModeDisabled";

interface IDemoDisabledTooltipProps {
    readonly children: ReactNode;
}

/**
 * Wraps an action that is disabled while a demo is active and shows the "disabled in demo mode" reason on hover.
 * Outside demo mode it is a transparent passthrough. The inline-flex wrapper keeps the toolbar layout and
 * receives the hover even when the inner control itself is disabled.
 */
export const DemoDisabledTooltip = ({ children }: IDemoDisabledTooltipProps) => {
    const { isDisabled, disabledTooltip } = useDemoModeDisabled();

    if (!isDisabled) {
        return <>{children}</>;
    }

    return (
        <Tooltip
            content={disabledTooltip}
            placement="top"
            enabled
        >
            <Flex inline>{children}</Flex>
        </Tooltip>
    );
};
